/* global axios */
import ApiClient from './ApiClient';

/**
 * The branch router: one row per branch, replacing a rule per branch.
 * See app/models/branch_route.rb for why the table exists at all.
 */
class BranchRoutesAPI extends ApiClient {
  constructor() {
    super('branch_routes', { accountScoped: true });
  }

  /**
   * Dry run. Answers where a message would go and why, without touching a conversation —
   * the only way to tell a correct route from one that is quietly shadowing another.
   */
  match(text) {
    return axios.post(`${this.url}/match`, { text });
  }
}

export default new BranchRoutesAPI();
